{
  "REPORT": {
    "HEADER": "Raporty rozmów",
    "LOADING_CHART": "Ładowanie danych wykresów...",
    "NO_ENOUGH_DATA": "Nie ma wystarczającej ilości danych do wygenerowania raportu. Spróbuj ponownie później.",
    "DOWNLOAD_AGENT_REPORTS": "Pobierz raporty agenta",
    "DATA_FETCHING_FAILED": "Nie udało się pobrać danych, spróbuj ponownie później.",
    "SUMMARY_FETCHING_FAILED": "Nie udało się pobrać podsumowania, spróbuj ponownie później.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Rozmowy",
        "DESC": "(łącznie)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Wiadomości przychodzące",
        "DESC": "(łącznie)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Wiadomości wychodzące",
        "DESC": "(łącznie)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Czas pierwszej odpowiedzi",
        "DESC": "(średni)",
        "INFO_TEXT": "Całkowita liczba rozmów używanych do obliczeń:",
        "TOOLTIP_TEXT": "Czas pierwszej odpowiedzi to {metricValue} (na podstawie {conversationCount} rozmów)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Czas rozwiązania",
        "DESC": "(średni)",
        "INFO_TEXT": "Całkowita liczba rozmów używanych do obliczeń:",
        "TOOLTIP_TEXT": "Czas rozwiązania to {metricValue} (na podstawie {conversationCount} rozmów)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Liczba rozwiązań",
        "DESC": "(łącznie)"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Liczba rozwiązań",
        "DESC": "(łącznie)"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Handoff Count",
        "DESC": "(łącznie)"
      },
      "REPLY_TIME": {
        "NAME": "Customer waiting time",
        "TOOLTIP_TEXT": "Waiting time is {metricValue} (based on {conversationCount} replies)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "TODAY": "Dzisiaj",
      "YESTERDAY": "Wczoraj",
      "LAST_7_DAYS": "Ostatnie 7 dni",
      "LAST_30_DAYS": "Ostatnie 30 dni",
      "THIS_MONTH": "Ten miesiąc",
      "LAST_MONTH": "Poprzedni miesiąc",
      "LAST_3_MONTHS": "Ostatnie 3 miesiące",
      "LAST_6_MONTHS": "Ostatnie 6 miesięcy",
      "LAST_YEAR": "Ostatni rok",
      "CUSTOM_DATE_RANGE": "Niestandardowy zakres dat"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Zastosuj",
      "PLACEHOLDER": "Wybierz zakres dat"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Grupuj według",
    "DURATION_FILTER_LABEL": "Czas trwania",
    "GROUPING_OPTIONS": {
      "DAY": "Dzień",
      "WEEK": "Tydzień",
      "MONTH": "Miesiąc",
      "YEAR": "Rok"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      },
      {
        "id": 3,
        "groupBy": "Month"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 2,
        "groupBy": "Week"
      },
      {
        "id": 3,
        "groupBy": "Month"
      },
      {
        "id": 4,
        "groupBy": "Year"
      }
    ],
    "BUSINESS_HOURS": "Godziny pracy",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Nie znaleziono rekordów"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "Rozmowy: {count}",
      "RESULT_COUNT_MESSAGE": "Wiadomości: {count}",
      "EMPTY": "Nie znaleziono rekordów dla tego słupka.",
      "ERROR": "Nie udało się wczytać rekordów. Spróbuj ponownie.",
      "LOAD_MORE": "Wczytaj więcej",
      "PREVIOUS_BUCKET": "Poprzedni słupek",
      "NEXT_BUCKET": "Następny słupek",
      "UNKNOWN_CONTACT": "Nieznany kontakt",
      "UNKNOWN_INBOX": "Nieznana skrzynka odbiorcza",
      "UNASSIGNED_AGENT": "Nieprzypisane",
      "NO_MESSAGE_CONTENT": "Brak treści wiadomości",
      "MESSAGE_CREATED_AT": "Wiadomość utworzona {time}",
      "EVENT_OCCURRED_AT": "Zdarzenie wystąpiło {time}",
      "INCOMING_MESSAGE": "Wiadomość przychodząca",
      "OUTGOING_MESSAGE": "Wiadomość wychodząca",
      "VIEW_ALL": "Pokaż w rozmowach",
      "VIEW_ALL_LIMIT": "Na liście rozmów otwierają się tylko słupki z maksymalnie {limit} rozmowami.",
      "HIDDEN_COUNT": "Nie pokazano, ponieważ nie jesteś członkiem ich skrzynki odbiorczej: {count}"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Przegląd agentów",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent’s name to learn more.",
    "LOADING_CHART": "Ładowanie danych wykresów...",
    "NO_ENOUGH_DATA": "Nie ma wystarczającej ilości danych do wygenerowania raportu. Spróbuj ponownie później.",
    "DOWNLOAD_AGENT_REPORTS": "Pobierz raporty agenta",
    "FILTER_DROPDOWN_LABEL": "Wybierz agenta",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Rozmowy",
        "DESC": "(łącznie)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Wiadomości przychodzące",
        "DESC": "(łącznie)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Wiadomości wychodzące",
        "DESC": "(łącznie)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Czas pierwszej odpowiedzi",
        "DESC": "(średni)",
        "INFO_TEXT": "Całkowita liczba rozmów używanych do obliczeń:",
        "TOOLTIP_TEXT": "Czas pierwszej odpowiedzi to {metricValue} (na podstawie {conversationCount} rozmów)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Czas rozwiązania",
        "DESC": "(średni)",
        "INFO_TEXT": "Całkowita liczba rozmów używanych do obliczeń:",
        "TOOLTIP_TEXT": "Czas rozwiązania to {metricValue} (na podstawie {conversationCount} rozmów)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Liczba rozwiązań",
        "DESC": "(łącznie)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Last 7 days"
      },
      {
        "id": 1,
        "name": "Last 30 days"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Zastosuj",
      "PLACEHOLDER": "Wybierz zakres dat"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Przegląd etykiet",
    "DESCRIPTION": "Śledź wydajność etykiet za pomocą kluczowych wskaźników, takich jak rozmowy, czasy odpowiedzi, czasy rozwiązania i rozwiązane sprawy.",
    "LOADING_CHART": "Ładowanie danych wykresów...",
    "NO_ENOUGH_DATA": "Nie ma wystarczającej ilości danych do wygenerowania raportu. Spróbuj ponownie później.",
    "DOWNLOAD_LABEL_REPORTS": "Pobierz raporty etykiety",
    "FILTER_DROPDOWN_LABEL": "Wybierz etykietę",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Rozmowy",
        "DESC": "(łącznie)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Wiadomości przychodzące",
        "DESC": "(łącznie)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Wiadomości wychodzące",
        "DESC": "(łącznie)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Czas pierwszej odpowiedzi",
        "DESC": "(średni)",
        "INFO_TEXT": "Całkowita liczba rozmów używanych do obliczeń:",
        "TOOLTIP_TEXT": "Czas pierwszej odpowiedzi to {metricValue} (na podstawie {conversationCount} rozmów)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Czas rozwiązania",
        "DESC": "(średni)",
        "INFO_TEXT": "Całkowita liczba rozmów używanych do obliczeń:",
        "TOOLTIP_TEXT": "Czas rozwiązania to {metricValue} (na podstawie {conversationCount} rozmów)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Liczba rozwiązań",
        "DESC": "(łącznie)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Last 7 days"
      },
      {
        "id": 1,
        "name": "Last 30 days"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Zastosuj",
      "PLACEHOLDER": "Wybierz zakres dat"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Przegląd skrzynki odbiorczej",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "Ładowanie danych wykresów...",
    "NO_ENOUGH_DATA": "Nie ma wystarczającej ilości danych do wygenerowania raportu. Spróbuj ponownie później.",
    "DOWNLOAD_INBOX_REPORTS": "Pobierz raporty skrzynki odbiorczej",
    "FILTER_DROPDOWN_LABEL": "Wybierz skrzynkę odbiorczą",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Rozmowy",
        "DESC": "(łącznie)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Wiadomości przychodzące",
        "DESC": "(łącznie)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Wiadomości wychodzące",
        "DESC": "(łącznie)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Czas pierwszej odpowiedzi",
        "DESC": "(średni)",
        "INFO_TEXT": "Całkowita liczba rozmów używanych do obliczeń:",
        "TOOLTIP_TEXT": "Czas pierwszej odpowiedzi to {metricValue} (na podstawie {conversationCount} rozmów)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Czas rozwiązania",
        "DESC": "(średni)",
        "INFO_TEXT": "Całkowita liczba rozmów używanych do obliczeń:",
        "TOOLTIP_TEXT": "Czas rozwiązania to {metricValue} (na podstawie {conversationCount} rozmów)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Liczba rozwiązań",
        "DESC": "(łącznie)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Last 7 days"
      },
      {
        "id": 1,
        "name": "Last 30 days"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Zastosuj",
      "PLACEHOLDER": "Wybierz zakres dat"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Przegląd zespołu",
    "DESCRIPTION": "Get a snapshot of your team’s performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "Ładowanie danych wykresów...",
    "NO_ENOUGH_DATA": "Nie ma wystarczającej ilości danych do wygenerowania raportu. Spróbuj ponownie później.",
    "DOWNLOAD_TEAM_REPORTS": "Pobierz raporty zespołu",
    "FILTER_DROPDOWN_LABEL": "Wybierz zespół",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Rozmowy",
        "DESC": "(łącznie)"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Wiadomości przychodzące",
        "DESC": "(łącznie)"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Wiadomości wychodzące",
        "DESC": "(łącznie)"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Czas pierwszej odpowiedzi",
        "DESC": "(średni)",
        "INFO_TEXT": "Całkowita liczba rozmów używanych do obliczeń:",
        "TOOLTIP_TEXT": "Czas pierwszej odpowiedzi to {metricValue} (na podstawie {conversationCount} rozmów)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Czas rozwiązania",
        "DESC": "(średni)",
        "INFO_TEXT": "Całkowita liczba rozmów używanych do obliczeń:",
        "TOOLTIP_TEXT": "Czas rozwiązania to {metricValue} (na podstawie {conversationCount} rozmów)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Liczba rozwiązań",
        "DESC": "(łącznie)"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Last 7 days"
      },
      {
        "id": 1,
        "name": "Last 30 days"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Zastosuj",
      "PLACEHOLDER": "Wybierz zakres dat"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "Raporty CSAT",
    "NO_RECORDS": "Brak dostępnych odpowiedzi w ankiecie CSAT.",
    "DOWNLOAD": "Pobierz raporty CSAT",
    "DOWNLOAD_FAILED": "Nie udało się pobrać raportów CSAT",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "Wybierz agentów"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Kontakt",
        "AGENT_NAME": "Przypisany agent",
        "RATING": "Ocena",
        "FEEDBACK_TEXT": "Tekst opinii"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Łącznie odpowiedzi",
        "TOOLTIP": "Całkowita liczba zebranych odpowiedzi"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Wskaźnik zadowolenia",
        "TOOLTIP": "Wskaźnik zadowolenia: (Liczba pozytywnych odpowiedzi / Całkowita liczba odpowiedzi) * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Wskaźnik odpowiedzi",
        "TOOLTIP": "Wskaźnik odpowiedzi: (Całkowita liczba odpowiedzi / Całkowita liczba wysłanych ankiet CSAT) * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot Reports",
    "METRIC": {
      "CONVERSATION_COUNT": {
        "LABEL": "Liczba rozmów",
        "TOOLTIP": "Łączna liczba rozmów z wiadomościami bota"
      },
      "OUTGOING_COUNT": {
        "LABEL": "Liczba odpowiedzi",
        "TOOLTIP": "Łączna liczba wiadomości wychodzących"
      },
      "MESSAGE_COUNT": {
        "LABEL": "Liczba odpowiedzi AI",
        "TOOLTIP": "Łączna liczba wiadomości odpowiedzi wysłanych przez bota"
      },
      "COPILOT_COUNT": {
        "LABEL": "Liczba przygotowanych odpowiedzi",
        "TOOLTIP": "Łączna liczba sugestii copilot przygotowanych przez bota dla agentów"
      },
      "SUCCESS_RATE": {
        "LABEL": "Rozwiązane przez AI",
        "TOOLTIP": "Procent rozmów rozwiązanych przez AI bez przekazania do agenta"
      },
      "RESOLVE_TIME": {
        "LABEL": "Czas rozwiązania",
        "TOOLTIP": "Mediana czasu od pierwszej wiadomości klienta do ostatniej wiadomości bota/agenta"
      },
      "TOTAL_CONVERSATIONS": {
        "LABEL": "No. of Conversations",
        "TOOLTIP": "Total number of conversations handled by the bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Total Responses",
        "TOOLTIP": "Total number of responses sent by the bot"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Resolution Rate",
        "TOOLTIP": "Total number of conversations resolved by the bot / Total number of conversations handled by the bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Handoff Rate",
        "TOOLTIP": "Total number of conversations handed off to agents / Total number of conversations handled by the bot * 100"
      }
    },
    "GROUP_BY": {
      "LABEL": "Grupuj według",
      "NONE": "Nie grupuj",
      "INBOXES": "Skrzynki odbiorcze",
      "LABELS": "Etykiety"
    },
    "GROUPED": {
      "CHART_TITLE": "Rozkład według grup",
      "BACK_TO_ALL": "Pokaż wszystkie",
      "TABLE": {
        "INBOX": "Skrzynka odbiorcza",
        "LABEL": "Etykieta",
        "CONVERSATIONS": "Rozmowy",
        "MESSAGES": "Wiadomości",
        "MESSAGES_TOOLTIP": "Łączna liczba wiadomości wychodzących",
        "AI_MESSAGES": "Odpowiedzi AI",
        "AI_MESSAGES_TOOLTIP": "Łączna liczba odpowiedzi AI, a następnie liczba pozytywnych i negatywnych ocen użytkowników końcowych",
        "THUMBS_UP_TOOLTIP": "Liczba odpowiedzi AI ocenionych pozytywnie (kciuk w górę) przez użytkowników końcowych",
        "THUMBS_DOWN_TOOLTIP": "Liczba odpowiedzi AI ocenionych negatywnie (kciuk w dół) przez użytkowników końcowych",
        "AI_PERCENTAGE": "AI %",
        "AI_PERCENTAGE_TOOLTIP": "Procent odpowiedzi AI ze wszystkich wiadomości w tej grupie",
        "PREPARED": "Przygotowane odpowiedzi",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "Procent wiadomości ze wszystkich wiadomości należących do tej grupy",
        "BOT_RESPONSES": "Odpowiedzi AI %",
        "SUGGESTION_USED": "Użyte odpowiedzi",
        "SUGGESTION_USED_TOOLTIP": "Procent przygotowanych odpowiedzi w tej grupie, które zostały użyte przez agentów",
        "SUGGESTION_NOT_USED": "Nieużyte odpowiedzi",
        "SUGGESTION_NOT_USED_TOOLTIP": "Procent wiadomości w tej grupie, które miały przygotowaną odpowiedź, ale nie została ona użyta"
      },
      "NOTES": {
        "TITLE": "Jak są obliczane metryki",
        "CONVERSATIONS": "Liczba rozmów, które mają co najmniej jedną wiadomość wychodzącą w wybranym okresie.",
        "MESSAGES": "Łączna liczba wiadomości wychodzących (nieprywatnych) wysłanych w wybranym okresie. Obejmuje zarówno wiadomości generowane przez AI, jak i pisane przez ludzi.",
        "PERCENTAGE": "Udział wiadomości tej grupy we wszystkich wiadomościach wychodzących w wszystkich grupach.",
        "AI_MESSAGES": "Liczba wiadomości wychodzących wysłanych automatycznie przez bota AI (nie obejmuje przygotowanych odpowiedzi dla agentów). Liczby w nawiasach pokazują, ile z tych odpowiedzi zostało ocenionych pozytywnie (kciuk w górę) i negatywnie (kciuk w dół) przez użytkowników końcowych.",
        "BOT_RESPONSES_PCT": "Udział odpowiedzi AI tej grupy we wszystkich wiadomościach wychodzących tej grupy.",
        "PREPARED": "Liczba sugestii copilot (przygotowanych odpowiedzi) wygenerowanych przez bota AI dla agentów w wybranym okresie. Są to prywatne wiadomości widoczne tylko dla agentów i nie są liczone jako wiadomości wychodzące, więc ta liczba może nie korelować z kolumną Wiadomości.",
        "SUGGESTION_USED": "Procent przygotowanych odpowiedzi w tej grupie, które zostały użyte przez agentów. Może to nie korelować z liczbą przygotowanych odpowiedzi, ponieważ może obejmować również sugestie wygenerowane w poprzednich okresach.",
        "SUGGESTION_NOT_USED": "Procent wiadomości wychodzących w tej grupie, gdzie sugestia copilot była dostępna, ale agent odpowiedział bez jej użycia. Liczone tylko wtedy, gdy agent faktycznie wysłał odpowiedź. Może to nie korelować z liczbą przygotowanych odpowiedzi, ponieważ może obejmować również sugestie wygenerowane w poprzednich okresach."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Przegląd",
    "LIVE": "Na żywo",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Aktywne rozmowy",
      "LOADING_MESSAGE": "Ładowanie metryk rozmów...",
      "OPEN": "Otwarte",
      "UNATTENDED": "Nieobsługiwane",
      "UNASSIGNED": "Nieprzypisane",
      "PENDING": "Oczekujące"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Ruch rozmów",
      "NO_CONVERSATIONS": "Brak rozmów",
      "CONVERSATION": "{count} rozmowa",
      "CONVERSATIONS": "{count} rozmowy",
      "DOWNLOAD_REPORT": "Download report"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Rozmowy według agentów",
      "LOADING_MESSAGE": "Ładowanie metryk agentów...",
      "NO_AGENTS": "Brak rozmów według agentów",
      "TABLE_HEADER": {
        "AGENT": "Agent",
        "OPEN": "Otwórz",
        "UNATTENDED": "Nieobsługiwane",
        "STATUS": "Status"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Zespół",
        "OPEN": "Otwórz",
        "UNATTENDED": "Nieobsługiwane",
        "STATUS": "Status"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Status agenta",
      "ONLINE": "Dostępny",
      "BUSY": "Zajęty",
      "OFFLINE": "Niedostępny"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Niedziela",
    "MONDAY": "Poniedziałek",
    "TUESDAY": "Wtorek",
    "WEDNESDAY": "Środa",
    "THURSDAY": "Czwartek",
    "FRIDAY": "Piątek",
    "SATURDAY": "Sobota"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA Reports",
    "NO_RECORDS": "SLA applied conversations are not available.",
    "LOADING": "Loading SLA data...",
    "DOWNLOAD_SLA_REPORTS": "Download SLA reports",
    "DOWNLOAD_FAILED": "Failed to download SLA Reports",
    "DROPDOWN": {
      "ADD_FIlTER": "Dodaj filtr",
      "CLEAR_ALL": "Clear all",
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Nie znaleziono rekordów",
      "NO_FILTER": "No filters available",
      "SEARCH": "Search filter",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA name",
        "AGENTS": "Nazwa agenta",
        "INBOXES": "Nazwa skrzynki odbiorczej",
        "LABELS": "Nazwa etykiety",
        "TEAMS": "Nazwa zespołu"
      },
      "SLA": "SLA Policy",
      "INBOXES": "Skrzynka odbiorcza",
      "AGENTS": "Agent",
      "LABELS": "Etykieta",
      "TEAMS": "Zespół"
    },
    "WITH": "with",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Hit Rate",
        "TOOLTIP": "Percentage of SLAs created were completed successfully"
      },
      "NO_OF_MISSES": {
        "LABEL": "Number of Misses",
        "TOOLTIP": "Total SLA misses in a certain period"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Number of Conversations",
        "TOOLTIP": "Total number of conversations with SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Policy",
        "CONVERSATION": "Rozmowa",
        "AGENT": "Agent"
      },
      "VIEW_DETAILS": "View Details"
    }
  },
  "SUMMARY_REPORTS": {
    "SUBTOTAL": "Suma częściowa",
    "NO_TEAM": "Brak zespołu",
    "GROUP_BY_TEAMS": "Grupuj według zespołów",
    "INBOX": "Skrzynka odbiorcza",
    "AGENT": "Agent",
    "TEAM": "Zespół",
    "LABEL": "Etykieta",
    "TOTAL": "Total",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Liczba rozwiązań",
    "CONVERSATIONS": "Ilość rozmów",
    "OUTGOING_CHATS": "Outgoing chats",
    "OUTGOING_EMAILS": "Outgoing emails",
    "PHONE_CALLS": "Phone calls",
    "INBOUND_CALLS": "Inbound calls",
    "OUTBOUND_CALLS": "Outbound calls",
    "TOTAL_ACTIVITIES": "Total activities",
    "ONLINE_TIME": "Online time",
    "QUEUE_AVAILABLE_TIME": "Queue available time",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "Number of outgoing messages sent by this agent",
      "OUTGOING_EMAILS": "Number of outgoing emails sent by this agent",
      "PHONE_CALLS": "Total number of phone calls assigned to this agent (sum of inbound and outbound calls)",
      "TOTAL_ACTIVITIES": "Total number of activities: inbound calls + outbound calls + outgoing chats + outgoing emails",
      "INBOUND_CALLS": "Number of inbound phone calls assigned to this agent",
      "OUTBOUND_CALLS": "Number of outbound phone calls assigned to this agent",
      "AVG_FIRST_RESPONSE_TIME": "Average time from conversation creation to first agent response in conversations assigned to this agent",
      "AVG_RESOLUTION_TIME": "Average time from conversation creation to resolution in conversations assigned to this agent",
      "AVG_REPLY_TIME": "Average time customers wait between their message and agent's reply in conversations assigned to this agent",
      "ONLINE_TIME": "Total time the agent was online or busy during the selected period",
      "QUEUE_AVAILABLE_TIME": "Total time the agent was available in phone queues during the selected period"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "Phone Reports",
    "DESCRIPTION": "Track phone call metrics with detailed insights on inbound and outbound calls, grouped by agent or inbox for comprehensive analysis.",
    "AGENT_HEADER": "Phone Reports - By Agent",
    "INBOX_HEADER": "Phone Reports - By Inbox",
    "DOWNLOAD_BUTTON": "Download Phone Reports",
    "DOWNLOAD_PHONE_REPORTS": "Download Phone Reports",
    "GROUP_BY": {
      "LABEL": "Group By",
      "AGENT": "Agent",
      "INBOX": "Inbox"
    },
    "TABLE": {
      "AGENT_NAME": "Agent Name",
      "INBOX_NAME": "Inbox Name",
      "TOTAL_CALLS": "Total",
      "INBOUND_CALLS": "Inbound",
      "OUTBOUND_CALLS": "Outbound",
      "FAILED_OUTBOUND_CALLS": "Failed outbound",
      "AVG_AGENT_HANDLED_DURATION": "Avg Duration",
      "TOTAL_AGENT_HANDLED_DURATION": "Total Duration",
      "AVG_RINGING_TIME": "Avg Ring Time",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Success %",
      "UNIQUE_CALLERS": "Unique Callers",
      "UNIQUE_CALLED_CONTACTS": "Unique Called",
      "UNANSWERED_MISSED_CALLS": "Missed no followup",
      "UNANSWERED_MISSED_PERCENTAGE": "Unaswered missed %",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Missed no followup, insufficiently called back",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Missed no followup, insufficiently called back %"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "Total number of all calls (including unconnected)",
      "INBOUND_CALLS": "Number of connected calls",
      "OUTBOUND_CALLS": "Number of all outbound calls (including unconnected)",
      "FAILED_OUTBOUND_CALLS": "Number of outbound calls that failed to connect",
      "AVG_AGENT_HANDLED_DURATION": "Average duration of calls handled by agents",
      "TOTAL_AGENT_HANDLED_DURATION": "Total duration of all calls handled by agents",
      "AVG_RINGING_TIME": "Average time calls spent ringing before being answered",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Percentage of outbound calls that were successfully connected",
      "UNIQUE_CALLERS": "Number of unique contacts who made inbound calls",
      "UNIQUE_CALLED_CONTACTS": "Number of unique contacts who were called via outbound calls",
      "UNANSWERED_MISSED_CALLS": "Number of missed calls where no successful callback was made (call connected). May include calls that can still be handled within the business day",
      "UNANSWERED_MISSED_PERCENTAGE": "Percentage of unique callers whose calls were missed without followup (unanswered missed calls / unique callers)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Number of missed calls with less than 2 callback attempts. May include calls that can still be handled within the business day",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Percentage of unique callers with less than 2 callback attempts ((missed no followup - sufficiently handled) / unique callers)"
    },
    "EMPTY_STATE": {
      "TITLE": "No phone call data available",
      "MESSAGE": "There are no phone calls in the selected date range. Try adjusting your filters or date range."
    }
  }
}
